module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('product-map', {
    attrs: {
      "data": _vm.data,
      "show_goods": false,
      "text": "添加图片"
    }
  })
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1c5cd2eb", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c5cd2eb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/pc/vipPage/components/plugins/poster/style.vue
// module id = 2514
// module chunks = 0